import React from 'react';

type VoidProps = {
  width?: number;
  height?: number;
};

const Void = ({ width = 32, height = 32 }: VoidProps) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='12' cy='12' r='12' fill='#EF5251' />
      <g clip-path='url(#clip0_3681_9736)'>
        <path
          d='M8.465 8.465L15.535 15.535M17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12Z'
          stroke='white'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_3681_9736'>
          <rect
            width='12'
            height='12'
            fill='white'
            transform='translate(6 6)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Void;
